<template>
  <div class="printer-config-button">
    <div
      class="printer-config-button__content"
      @click="openPrinterModal"
    >
      <svg-loader src="/static/images/config.svg" />
      <span v-if="labelText">{{ labelText }}</span>
      <md-tooltip
        md-delay="400"
        :md-direction="tooltipDirection"
      >
        {{ tooltipText }}
      </md-tooltip>
    </div>

    <!-- Modal -->
    <PrinterModal ref="printerModal" />
  </div>
</template>

<script>
import PrinterModal from "./PrinterModal.vue";

export default {
  name: "PrinterConfigButton",
  components: {
    PrinterModal,
  },
  props: {
    iconClass: {
      type: String,
      default: "icon-printer-pos-cog",
    },
    labelText: {
      type: String,
      default: "",
    },
    tooltipText: {
      type: String,
      default: "",
    },
    tooltipDirection: {
      type: String,
      default: "bottom",
    },
  },
  methods: {
    openPrinterModal() {
      this.$refs.printerModal.open();
    },
  },
};
</script>

<style lang="scss" scoped>
.printer-config-button {
  display: inline-flex;
  align-items: center;

  &__content {
    display: flex;
    align-items: center;
    font-weight: 500;
    color: #7a7a7a;
    cursor: pointer;

    span {
      margin-left: 8px;
      font-size: 14px;
      white-space: nowrap;
      user-select: none;
    }

    .md-icon {
      width: 24px;
      height: 24px;
      flex-shrink: 0;

      :deep(svg) {
        path {
          fill: #7a7a7a;
        }
      }
    }
  }
}
</style>
